import React, { useContext, useEffect, useState } from 'react';

import { getJobOpeningNotification } from '../JobOpening/jobOpeningApi';
import { AuthContextValue, NotificationContextValue } from './types';
import { useNotify } from './snackbarHooks';
import AuthContext from './AuthContext';

export const NotificationContext = React.createContext({});

type Props = {
  children: React.ReactNode;
};

export const NotificationProvider: React.FC<Props> = ({ children }) => {
  // hooks
  const [jobOpeningsCount, setJobOpeningsCount] = useState<number>(0);
  const { isAuth, hasPermissions } = useContext(AuthContext) as AuthContextValue;
  const { notifyError } = useNotify();

  useEffect(() => {
    if (isAuth) {
      if (hasPermissions(['admin', 'operational_leader', 'operational_manager', 'regional_manager'])) {
        getJobOpeningNotification()
          .then(({ data }) => {
            setJobOpeningsCount(data.count);
          })
          .catch(() => notifyError('Det gick inte att hämta jobbannons underrättelse'));
      }
    }
  }, [isAuth]);

  // functions
  const refreshJobOpeningsNotification = (): void => {
    getJobOpeningNotification()
      .then(({ data }) => {
        setJobOpeningsCount(data.count);
      })
      .catch(() => notifyError('Det gick inte att hämta jobbannons underrättelse'));
  };

  const defaultContext: NotificationContextValue = {
    jobOpeningsCount,
    refreshJobOpeningsNotification,
  };

  // render
  return (
    <React.Fragment>
      <NotificationContext.Provider value={defaultContext}>{children}</NotificationContext.Provider>
    </React.Fragment>
  );
};

export default NotificationContext;
